import React from 'react';
import './LoadingSpinner.scss';
import classNames from 'classnames';

export default function Loading({ small, className, ...props }: { small?: boolean; className?: string }) {
  return (
    <div
      className={classNames('flex flex-col items-center justify-center h-full', className, {
        small: small,
      })}
      data-testid="loading-spinner"
      {...props}
    >
      <div className="loading-spinner">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
